<script>
    import {config} from './stores.js';
    import {getConfig, loadState, makeElementsClickable} from './util';
    import Consent from './Consent.svelte';
    import {onDestroy, onMount} from 'svelte';
    import {trackEvent} from './tracking';

    export let configOverride = {};
    let mutationObserver;

    $config = loadState(getConfig(configOverride));

    if (window.location.pathname.includes("datenschutz.html")) {
        $config.display = false;
    }

    const initTriggers = () => {
        makeElementsClickable({
            selector: '[data-open-privacy-settings="true"]',
            containerElement: document,
            callback: e => {
                e.preventDefault();
                $config.display = true;
                trackEvent({
                    category: 'e_consent__open',
                    action: 'basic',
                    eventIsNonInteraction: false,
                });
            },
        });
    };

    onMount(async () => {
        mutationObserver = new MutationObserver(() => {
            initTriggers();
        });

        mutationObserver.observe(document, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        initTriggers();
    });

    onDestroy(async () => {
        mutationObserver.disconnect();
    });
</script>

{#if window.e_consent_debug === true}
    <pre style="max-width: 100%; overflow: auto;">
    {JSON.stringify($config, null, 2)}
    </pre>
{/if}

{#if $config.display === true}
    <Consent/>
{/if}
